import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class SystemUserModel extends BaseModel {

    constructor(source?: SystemUserModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._systemUserID = 0;
            this._userTypeID = 0;
        }
    }

// private properties
    _systemUserID: number = 0;
    _userTypeID: number = 0;
    _username: string = "";
    _fullName: string | null = null;
    _password: string | null = null;
    _lastLogin: Date | null = null;
    _locked: boolean = false;
    _active: boolean = true;

// public properties
    public get systemUserID(): number
    {
        return this._systemUserID;
    }
    public set systemUserID(v: number)
    {
        if (v !== this._systemUserID)
        {
            this._systemUserID = v;
            this.propertyChanged.emit(new propertyChangedArguments("systemUserID", this));
        }
    }

    public get userTypeID(): number
    {
        return this._userTypeID;
    }
    public set userTypeID(v: number)
    {
        if (v !== this._userTypeID)
        {
            this._userTypeID = v;
            this.propertyChanged.emit(new propertyChangedArguments("userTypeID", this));
        }
    }

    public get username(): string
    {
        return this._username;
    }
    public set username(v: string)
    {
        if (v !== this._username)
        {
            this._username = v;
            this.propertyChanged.emit(new propertyChangedArguments("username", this));
        }
    }

    public get fullName(): string | null
    {
        return this._fullName;
    }
    public set fullName(v: string | null)
    {
        if (v !== this._fullName)
        {
            this._fullName = v;
            this.propertyChanged.emit(new propertyChangedArguments("fullName", this));
        }
    }

    public get password(): string | null
    {
        return this._password;
    }
    public set password(v: string | null)
    {
        if (v !== this._password)
        {
            this._password = v;
            this.propertyChanged.emit(new propertyChangedArguments("password", this));
        }
    }

    public get lastLogin(): Date | null
    {
        return this._lastLogin;
    }
    public set lastLogin(v: Date | null)
    {
        if (v !== this._lastLogin)
        {
            this._lastLogin = v;
            this.propertyChanged.emit(new propertyChangedArguments("lastLogin", this));
        }
    }

    public get locked(): boolean
    {
        return this._locked;
    }
    public set locked(v: boolean)
    {
        if (v !== this._locked)
        {
            this._locked = v;
            this.propertyChanged.emit(new propertyChangedArguments("locked", this));
        }
    }

    public get active(): boolean
    {
        return this._active;
    }
    public set active(v: boolean)
    {
        if (v !== this._active)
        {
            this._active = v;
            this.propertyChanged.emit(new propertyChangedArguments("active", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: SystemUserModel): void {
        if (source == null) return;
        this._systemUserID = source.systemUserID;
        this._userTypeID = source.userTypeID;
        this._username = source.username;
        this._fullName = source.fullName;
        this._password = source.password;
        this._lastLogin = source.lastLogin;
        this._locked = source.locked;
        this._active = source.active;
    }


}
